import { CFormCheck } from '@coreui/react';
import React from 'react';

type RadioGroupBtnProps = {
  name: string;
  label?: string;
  className?: string;
  value?: string | string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  required?: boolean;
  options: { id: string; name: string; label?: string }[];
  isButton?: boolean;
  disabled?: boolean;
  multiple?: boolean;
  btnSize?: 'lg' | 'sm';
};

const RadioGroupBtn: React.FC<RadioGroupBtnProps> = ({
  label,
  className,
  name,
  onChange,
  message,
  required,
  options,
  value,
  disabled,
  isButton = true,
  multiple = false,
  btnSize = 'sm',
}) => {
  const isChecked = (id: string) => {
    if (multiple && Array.isArray(value)) return value.includes(id);
    return value == id;
  };

  return (
    <div className={`form-outline text-start ${label ? 'mt-2' : ''} ${className}`}>
      {label && <label className="login_label labelName mb-2">{label}</label>}

      <div className="gap-2 d-flex flex-wrap">
        {options.map((option, index) => (
          <CFormCheck
            key={index}
            disabled={disabled}
            inline
            id={`${name}_${option.id}`}
            name={name}
            type={multiple ? 'checkbox' : 'radio'} // ✅ switch type
            value={option.id}
            autoComplete="off"
            label={option.name}
            onChange={onChange}
            checked={isChecked(option.id?.toString())}
            className="w-auto"
            {...(isButton
              ? { button: { color: 'primary', variant: 'outline', size: btnSize } }
              : {})}
          />
        ))}
      </div>

      {required && <span className="top-90 invalid-tooltip">{message}</span>}
    </div>
  );
};

export default RadioGroupBtn;
